// Sign-out helpers shared by the portal chrome (Header) and the health module
// header (HealthLayout), so the SignOutMenu behaves identically in both.

const SIGN_OUT_ALL_MSG =
  'Sign out all devices?\n\nThis ends every signed-in Parish Portal session for your ' +
  'account, on every device, including this one. Other devices are signed out within ' +
  'about a minute. You can sign straight back in.';

/** This device only — the existing logout route (clears the session cookie). */
export function signOutThisDevice(): void {
  window.location.href = '/auth/logout';
}

/** Every device — bumps the per-email session epoch, then lands on login. */
export function signOutAllDevices(): void {
  if (!window.confirm(SIGN_OUT_ALL_MSG)) return;
  // Only redirect on a confirmed success — a failed "sign out all" must never be
  // silently shown as done (House Rules O: loud failure).
  void fetch('/api/auth/logout-all', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        window.location.assign('/');
      } else {
        window.alert('Could not sign out all devices. Please try again.');
      }
    })
    .catch(() =>
      window.alert('Could not sign out all devices. Please check your connection and try again.'),
    );
}
